import { render, staticRenderFns } from "./CourseChangeSigningStatusModal.vue?vue&type=template&id=4dae945c&"
import script from "./CourseChangeSigningStatusModal.vue?vue&type=script&lang=ts&"
export * from "./CourseChangeSigningStatusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
